<script>
import moment from 'moment'

export default {
  data () {
    return {
      hours: ''
    }
  },
  components: {
  },
  mounted () {
    this.getHours()
  },
  methods: {
    getHours () {
      let endpoint = '/api/v1/hours/' + moment().format('dddd')
      this.$http.get(endpoint).then((response) => {
        // success callback
        this.hours = response.body.data[0][0]
      }, (response) => {
        // error callback

      })
    }
  }
}
</script>
